package com.vamvisions.main.portfolio.presentation.projects

import com.vamvisions.main.core.presentation.i18n.UiText
import com.vamvisions.main.core.presentation.navigation.Route
import com.vamvisions.main.portfolio.domain.model.Store
import com.vamvisions.main.portfolio.presentation.common.SkillUi

/**
 * The projects split into the [featured] ones ("Now") and the [earlier] ones, each in the server's order. While the
 * language changes, both keep the previous content with [isLoading] true.
 */
data class ProjectsState(
    val isLoading: Boolean = true,
    val featured: List<ProjectUi> = emptyList(),
    val earlier: List<ProjectUi> = emptyList(),
    val error: UiText? = null,
) {
    val hasContent: Boolean get() = featured.isNotEmpty() || earlier.isNotEmpty()
}

/**
 * [description] is null when the project has none. [meta] is the line above the name: the project's meta line, or
 * its year when it has none. [comingSoon] shows the "Coming soon" badge. [policyRoute] points to the privacy policy in
 * the language the content was loaded in. [storeLinks] keep the server's order and are empty when the project is in no
 * store. [websiteUrl] is null when it has no live website, and [sourceUrl] when it has no public source code.
 */
data class ProjectUi(
    val slug: String,
    val name: String,
    val description: String?,
    val meta: String,
    val comingSoon: Boolean,
    val iconUrl: String,
    val skills: List<SkillUi>,
    val policyRoute: Route.ProjectDocument?,
    val storeLinks: List<StoreLinkUi>,
    val websiteUrl: String?,
    val sourceUrl: String?,
)

/** The store page of a project: which [store] it is in, and its absolute [url]. */
data class StoreLinkUi(
    val store: Store,
    val url: String,
)
